/* global $ */

$('.selectmultiple').each(function() {
    "use strict";
    $(this).selectpicker({
        noneSelectedText: 'Please select'
    }).selectpicker('setStyle', 'btn btn-default', 'remove').selectpicker('setStyle', 'form-control', 'add');
});
